import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import { StoreProvider } from './store/store-provider';
import ErrorBoundary from './components/error-boundary/error-boundary';


ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <ErrorBoundary>
        <App/>
      </ErrorBoundary>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
